// useBeforeUnload.ts
import { useEffect } from 'react';

export const useBeforeUnload = (isActive: boolean, message: string) => {
  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (isActive) {
        event.preventDefault();
        event.returnValue = message; // For most browsers
        return message; // For older browsers
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [isActive, message]);
};

